"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _icons = require("../icons");

var _helperComponents = require("./helperComponents");

var _core = require("@emotion/core");

var EllipsisItem = function EllipsisItem() {
  return (0, _core.jsx)(_helperComponents.PaginationLi, {
    role: "listitem"
  }, (0, _core.jsx)(_helperComponents.StyledEllipsisItem, null, (0, _core.jsx)(_icons.IconMoreHorizontal, {
    color: "neutral70",
    title: "ellipsis"
  })));
};

EllipsisItem.displayName = 'EllipsisItem';
var _default = EllipsisItem;
exports.default = _default;